<template>
    <div class="contain">
      <!-- 顶部-->
      <div class="top">
        <div class="top-content"><a :href="Link_url.urll">统一身份认证登录</a></div>
      </div>
      <!-- logo-->
      <div class="w100 bgc-f">
        <div class="w12 logo-h">
          <div class="logo" v-if="topicArr" @click="jumpIndex"><img :src="Link_url.url+topicArr" :alt="topicArr.pre"></div>
          <div class="navbar-form navbar-right search r">
            <div class="form-group">
              <input type="text" class="form-control" v-model="searchInfo"
                placeholder="站内搜索" @keyup.enter="jumpSearch(searchInfo)">
            </div>
            <a href='javascript:;' class="btn btn-default" @click="jumpSearch(searchInfo)">
              <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
            </a>
          </div>
        </div>
        <!-- 导航 -->
        <div class="w12 menu bgc-f">
          <ul>
            <li><router-link to="/index">网站首页</router-link></li>
            <li v-for="(item,index) in tabList" :key="index">
              <router-link :to=/list/+item.id>{{item.name}}</router-link>
            </li>
           <li class="last"><a :href="Link_url.jumpUrl+'/#/home/login'" target="_blank">在线报名</a></li>
            
          </ul>
        </div>
      </div>
      <!-- 提示框 -->
      <tip :tip="tip" v-show="tipShow"></tip>
      <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
    </div>
</template>

<script>
import { getTopic, getArtCates } from "../api/api";
import { Link_url } from "../api/config";
import pageLoad from "../pageload/pageload";
export default {
  components: { pageLoad },
  data() {
    return {
      Link_url: Link_url, //地址
      topicArr: {}, //保存专题详情
      tabList: [], //保存tablist数据
      searchInfo: "",
      tip: "", //提示语
      tipShow: false, //提示框默认状态
      loading: true //预加载
    };
  },
  created() {
    this._getTopic(); //网站的logo
  },
  methods: {
    // 获取专题详情,上传网站的logo
    _getTopic() {
      let logo = JSON.parse(sessionStorage.getItem("logo"));
      this.loading = true;
      if (logo == null) {
        let module = {
          sch_id: 1,
          topic_id: 2
        };
        getTopic(module)
          .then(res => {
            if (res.status && res.data) {
              sessionStorage.setItem("logo", JSON.stringify(res));
              this.topicArr = res.data.logo;
              this._getArtCates(); //循环tab栏目
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.topicArr = logo.data.logo;
        this._getArtCates(); //循环tab栏目
      }
    },
    // 获取栏目列表，循环tab栏目
    _getArtCates() {
      let teb = JSON.parse(sessionStorage.getItem("teb"));

      if (teb == null) {
        let module = {
          sch_id: 1,
          topic_id: 2
        };
        getArtCates(module)
          .then(res => {
            this.loading = false;
            if (res.status && res.data && res.data.length > 0) {
              sessionStorage.setItem("teb", JSON.stringify(res));
              for (let l = 0; l < res.data.length; l++) {
                if (res.data[l].id >= 31 && res.data[l].id <= 40) {
                  this.tabList.push(res.data[l]);
                }
              }
            } else {
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.loading = false;
        for (let l = 0; l < teb.data.length; l++) {
          if (teb.data[l].id >= 31 && teb.data[l].id <= 40) {
            this.tabList.push(teb.data[l]);
          }
        }
      }
    },
    //跳转到搜索页
    jumpSearch(item) {
      if (item == "") {
        this.tipCtr("请输入关键字");
      } else {
        this.$router.push({ path: "/search/" + item });
        this.searchInfo = "";
      }
    },
    jumpIndex() {
      this.$router.push({ path: "/index" });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    }
  }
};
</script>

<style scoped>
/*头部*/
.top {
  width: 100%;
  height: 30px;
  background: #428bca;
  min-width: 1200px;
}
.top-content {
  width: 1200px;
  margin: 0 auto;
  text-align: right;
  line-height: 30px;
}

.top-content a {
  color: #ffffff;
}
.top-content a:hover {
  color: #fd1;
}
/*logo*/
.logo-h {
  height: 80px;
}
.logo {
  width: 500px;
  height: 100%;
  float: left;
}
.logo img {
  margin-top: 15px;
}
.logo img:hover {
  cursor: pointer;
}
.search.r {
  overflow: hidden;
  padding: 0;
  margin-top: 25px;
  margin-right: 0 !important;
}
/*menu*/
.menu ul li {
  float: left;
  text-align: center;
  width: 11%;
  transition-duration: 0.6s
}
.menu ul li a {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  width: 100%;
  height: 50px;
  line-height: 50px;
   transition-duration: 0.6s
}
/* .menu ul li:nth-child(8) a,
.menu ul li:last-child a {
  color: #f00;
} */
.router-link-active {
  background: #428bca;
  color: #ffffff !important;
}
.menu ul li:hover a {
  background: #428bca;
  color: #ffffff;
}
.last a {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headComp.vue